<div class="tabs-nav" [class.segment]="variant() === 'segment'">
  @for (tab of tabs(); track tab.id) {
    <button #tabButton class="tab-button" [class.active]="activeTab().id === tab.id" (click)="onTabChange(tab, tabButton)">
      {{ tab.label }}
    </button>
  }
  <div class="tab-underline" [style.left.px]="underlineLeft()" [style.width.px]="underlineWidth()"></div>
</div>
